var cookieDeviceDomain = ".bloon.io";
var cookieExpireTimeForever = 1000 * 365; // 1000 years
var Cookies = require("../../assets-protected/js/js.cookie-2.2.0.min.js");

// --------------------------------------------------
// function define
// --------------------------------------------------
function setCookieForever(key, value) {
    if (window.location.hostname.endsWith(cookieDeviceDomain)) {
        // for production env.
        Cookies.set(key, value, {
            domain: cookieDeviceDomain,
            expires: cookieExpireTimeForever, secure: true, path: "/"
        });
    } else {
        // for test env. (just without domain)
        Cookies.set(key, value, {
            expires: cookieExpireTimeForever, secure: true, path: "/"
        });
    }
}
// --------------------------------------------------
function toCleanAnalyticsTypeCookies() {
    for (let i = 0; i < KEYS_TO_DEL_TYPE_ANALYTICS__JSON_ARRAY.length; ++i) {
        var tmp_key = KEYS_TO_DEL_TYPE_ANALYTICS__JSON_ARRAY[i];
        if (window.location.hostname.endsWith(cookieDeviceDomain)) {
            // for production env.
            Cookies.remove(tmp_key, {
                domain: cookieDeviceDomain,
                secure: true, path: "/"
            });
        } else {
            // for test env. (just without domain)
            Cookies.remove(tmp_key, {
                secure: true, path: "/"
            });
        }
    }
}
// --------------------------------------------------
function toShowCcp() {
    $(".ccp-root").css({ display: "flex" });
}
// --------------------------------------------------
function toHideCcp() {
    $(".ccp-root").css({ display: "none" });
}
// --------------------------------------------------
function toShowCpp() {
    $(".cpp-root").css({ display: "flex" });
    $(".cpp-root-background-opacity-mask").css({ display: "block" });
    // to hinde HTML root scrollbar for RWD small size
    $("html").css({ "overflow-y": "hidden" });
}
// --------------------------------------------------
function toHideCpp() {
    $(".cpp-root").css({ display: "none" });
    $(".cpp-root-background-opacity-mask").css({ display: "none" });
    // to restore HTML root scrollbar
    $("html").css({ "overflow-y": "" });
}
// --------------------------------------------------
// direct exec
// --------------------------------------------------
var disable_analytics_type = Cookies.get("disableCookieType_Analytics", { domain: cookieDeviceDomain, path: "/" });
if (!disable_analytics_type) {
    // disable_analytics_type is "undefined" means "haven't press I AGREE button."
    toShowCcp();
}
// --------------------------------------------------
$(".ccp-root a, .cpp-root a").each(function () {
    $(this).attr("target", "_blank");
    $(this).attr("rel", "noopener noreferrer");
});
// --------------------------------------------------
$(".i-agree-btn-elem").on("click", function () {
    var tmp_value = Cookies.get("disableCookieType_Analytics", { domain: cookieDeviceDomain, path: "/" });
    // in fact, no need to check (must be "undefined") but checking anyway
    if (!tmp_value) {
        setCookieForever("disableCookieType_Analytics", "no");
    }
    toHideCcp();
});
// --------------------------------------------------
$("#preferences-ancher-elem").on("click", function (evt) {
    var disable_analytics_type = Cookies.get("disableCookieType_Analytics", { domain: cookieDeviceDomain, path: "/" });
    if (disable_analytics_type && disable_analytics_type === "yes") {
        $("#analytics-cb-elem").get(0).checked = false;
    } else {
        $("#analytics-cb-elem").get(0).checked = true;
    }
    toShowCpp();
    evt.preventDefault();
});
// --------------------------------------------------
$("#cancel-ancher-elem").on("click", function (evt) {
    toHideCpp();
    evt.preventDefault();
});
// --------------------------------------------------
$(".confirm-btn-elem").on("click", function (evt) {
    var analytics_switchOn = $("#analytics-cb-elem").get(0).checked;
    if (analytics_switchOn) {
        setCookieForever("disableCookieType_Analytics", "no");
    } else {
        setCookieForever("disableCookieType_Analytics", "yes");
        toCleanAnalyticsTypeCookies();
    }
    toHideCpp();
    toHideCcp();
});


// --------------------------------------------------
// --------------------------------------------------
// --------------------------------------------------
// --------------------------------------------------
// --------------------------------------------------
// // test only
// $("#preferences-ancher-elem").click();
